<template>
    <span
        v-if="isLoading"
        class="spinner-border spinner-border-lg"
        role="status"
        aria-hidden="true"
    ></span>
</template>

<script>
    export default {
        props: ['isLoading']
    }
</script>
